import React from "react";
import styled from "styled-components";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import Comments from "../components/Comments";
import Card from "../components/Card";
import syntalix from '../img/IMG_20231218_101705.png';

const Container = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Content = styled.div`
  flex: 5;
  width: 100%;
`;

const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 56.25%; /* Maintain 16:9 aspect ratio for desktop */
  overflow: hidden;

  @media (max-width: 768px) {
    padding-top: 75%; /* Adjusting aspect ratio for mobile devices */
  }
`;

const VideoFrame = styled.iframe`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text};
`;

const Details = styled.div`
 display: flex;
  flex-direction: column; /* Adjusting the details layout for mobile */
  gap: 10px;
  /* align-items: center; */

  @media (min-width: 768px) {
    display: flex;
  /* align-items: center; */
  justify-content: space-between;
  flex-direction: column; /* Reverting to the original layout for larger screens */

  }
`;

const Info = styled.span`
  color: ${({ theme }) => theme.textSoft};
`;

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  color: ${({ theme }) => theme.text};
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;

const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.soft};
`;

const Recommendation = styled.div`
  flex: 2;
  border-radius: 25px;
  padding: 15px;
  background-color: rgba(66, 62, 62, 0.505);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(5px);
  margin-top: 20px;

  @media (min-width: 768px) {
    margin-top: 0; /* Reverting margin for larger screens */
  }
`;

const Channel = styled.div`
  /* display: flex; */
  /* justify-content: space-between; */
  flex-direction: column; /* Adjusting the layout for mobile */
  /* align-items: flex-start; */
  gap: 10px;

  @media (min-width: 768px) {
    flex-direction: row; /* Reverting to the original layout for larger screens */
  }
`;

const ChannelInfo = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  @media (min-width: 768px) {
    align-items: flex-start; /* Adjusting alignment for larger screens */
  }
`;

const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

const ChannelDetail = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.text};
`;

const ChannelName = styled.span`
  font-weight: 500;
`;

const ChannelCounter = styled.span`
  margin-top: 5px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.textSoft};
  font-size: 12px;
`;

const Description = styled.p`
  font-size: 14px;
  color: white;
`;

const Subscribe = styled.button`
  background-color: #cc1a00;
  font-weight: 500;
  color: white;
  border: none;
  border-radius: 3px;
  height: max-content;
  padding: 10px 20px;
  cursor: pointer;
`;

const Video = () => {
  return (
    <Container>
      <Content>

        <VideoWrapper>
        <VideoFrame
          src="https://www.youtube.com/embed/JYx6VLTLMCs"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></VideoFrame>

        </VideoWrapper>
        <Details>
        <Title>What are We?</Title>
          <Info>7,948,154 views • Jun 22, 2022</Info>
          <Buttons>
            <Button>
              <ThumbUpOutlinedIcon /> 123
            </Button>
            <Button>
              <ThumbDownOffAltOutlinedIcon /> Dislike
            </Button>
            <Button>
              <ReplyOutlinedIcon /> Share
            </Button>
            <Button>
              <AddTaskOutlinedIcon /> Save
            </Button>
          </Buttons>
        </Details>
        <Hr />
        <Channel>
          <ChannelInfo>
            <Image src={syntalix} />
            <ChannelDetail>
              <ChannelName>Syntalix</ChannelName>
              <ChannelCounter>200K subscribers</ChannelCounter>
            </ChannelDetail>
          </ChannelInfo>
          <Description>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            Doloribus laborum delectus unde quaerat dolore culpa sit aliquam
            at. Vitae facere ipsum totam ratione exercitationem. Suscipit
            animi accusantium dolores ipsam ut.
          </Description>
          <Subscribe>SUBSCRIBE</Subscribe>
        </Channel>
        <Hr />
        <Comments />
      </Content>
      <Recommendation>
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
        <Card type="sm" />
      </Recommendation>
    </Container>
  );
};

export default Video;
